import { IAlertMessage } from '../../common/contracts';

export const pharmaceuticalFormAlertMessages: IAlertMessage = {
  success: {
    title: 'Cadastro realizado.',
    subTitle: 'Bem vindo ao programa, você será redirecionado para o Portal do Farmacêutico.',
    status: 'success',
  },
  defaultError: {
    title: 'Ocorreu um erro ao realizar o seu cadastro.',
    subTitle: 'Não foi possível realizar o seu cadastro.',
    status: 'error',
  },
  successUpdatePharmaceutical: {
    title: 'Farmacêutico atualizado com sucesso.',
    subTitle: 'Você será redirecionado para o Portal do Farmacêutico.',
    status: 'success',
  },
};
